import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async canales(usuario) {
    const response = await api.post(API_URL + "canales", usuario);
    if (response.data) return response.data;
  },

  async guardaCanal(canal) {
    const response = await api.post(API_URL + "guardaCanal", canal);
    if (response.data) return response.data;
  },

  async borraCanal(userId) {
    const response = await api.post(API_URL + "borraCanal", userId);
    if (response.data) return response.data;
  },

  async listaCanales(tipster) {
    const response = await api.post(API_URL + "listaCanales", tipster);
    if (response.data) return response.data;
  },

  async verificarCanal(data) {
    const response = await api.post(API_URL + "verificarCanal", data);
    if (response.data) return response.data;
  },

  async tablaCanales(payload) {
    const response = await api.post(API_URL + "tablaCanales", payload);
    return response.data;
  },

  async productosDelCanal(canal_id) {
    const response = await api.post(API_URL + "canales/productos", { canal_id });
    if (response.data) return response.data;
  },

  async exportarCanales() {
    return await api.post(API_URL + "canales/export", {}, { responseType: "blob" });
  },

  async exportarGrupoTelegram(idCanal) {
    return await api.post(API_URL + "grupoTelegram/export", { idCanal }, { responseType: "blob" });
  },
};
